/* src/app/components/account/manage-case/manage-case.component.scss */
.mat-sort-header-container {
  align-items: center;
}
tr.mat-row:hover {
  background-color: #eeeeee;
  cursor: pointer;
}
.mat-mdc-row.selected {
  background-color: #f5f5f5;
}
.header-row {
  background-color: #F5F5F5;
  color: #00008A;
}
td.mat-mdc-cell {
  padding: 16px 0;
  border-bottom: 1px solid #ffa600;
  border-top: 1px solid #ffa600;
}
td.mat-mdc-cell:first-child {
  border-left: 1px solid #ffa600;
}
td.mat-mdc-cell:last-child {
  border-right: 1px solid #ffa600;
}
table {
  border-spacing: 0 8px !important;
}
::ng-deep .tooltip-list {
  white-space: pre;
  font-size: 12px;
}
:host-context(.dark-theme) tr.mat-row:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
/*# sourceMappingURL=manage-case.component.css.map */
